export default __webpack_public_path__ + "static/media/Deloitte Consulting.46ffb6ff.png";